import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, ShieldCheck, Lock } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";
import { formatApiError } from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim(), password);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed.");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen brand-gradient relative overflow-hidden grid place-items-center px-5">
      <div className="absolute inset-0 grain opacity-30" />
      <form onSubmit={submit} className="relative w-full max-w-md rounded-3xl bg-white p-8 card-shadow" data-testid="admin-login-form">
        <div className="flex items-center gap-3">
          <div className="grid place-items-center h-11 w-11 rounded-xl bg-navy"><ShieldCheck className="text-gold" /></div>
          <div>
            <div className="font-heading font-extrabold text-navy text-lg">Advisor Login</div>
            <div className="text-xs text-slate-400">Financial Health Check-Up Admin</div>
          </div>
        </div>

        <div className="mt-8 space-y-4">
          <div>
            <Label className="text-xs font-semibold text-slate-600">Email</Label>
            <Input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 rounded-lg" placeholder="you@example.com" required />
          </div>
          <div>
            <Label className="text-xs font-semibold text-slate-600">Password</Label>
            <Input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 rounded-lg" placeholder="••••••••" required />
          </div>
        </div>

        <button data-testid="admin-login-submit" disabled={loading}
          className="mt-7 w-full rounded-full bg-navy text-white font-heading font-bold py-3.5 flex items-center justify-center gap-2 hover:bg-royal transition-colors duration-300 disabled:opacity-60">
          {loading ? <Loader2 className="animate-spin" size={18} /> : <><Lock size={16} /> Sign In</>}
        </button>
        <button type="button" onClick={() => navigate("/")} className="mt-4 w-full text-center text-xs text-slate-400 hover:text-navy transition-colors duration-200">
          ← Back to website
        </button>
      </form>
    </div>
  );
}
